import React from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import APIService from "../Services/API/APIService";
import {
  Form,
  Input,
  Button,
  Card,
  Grid,
  Dimmer,
  Loader,
  Message,
  Container,
} from "semantic-ui-react";
import Navbar from "../Components/NavHeader";

const ForgotPassword = (props) => {
  const [loading, setLoading] = React.useState(false);
  const [alert, setAlert] = React.useState({ show: false, message: "" });

  const schema = Yup.object().shape({
    email: Yup.string().email("Invalid Email").required("Required"),
  });

  const _resetPassword = async (credentials) => {
    try {
      // console.log('credentials', credentials)
      setLoading(true);
      await  APIService.postData("/auth/forgotPassword", credentials);

      setAlert({
        show: true,
        message: "Password reset instructions have been sent to your mailbox",
      });
      setLoading(false);
   
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
  };

  return (
    <Container fluid>
      {loading && (
        <Dimmer active inverted>
          <Loader > Processing ... </Loader>
        </Dimmer>
      )}

     <Navbar/>

      <Grid centered >
  

        {alert?.show && (
        <Card centered>
          <Message success>
            <p>{alert.message}</p>
          </Message>
        </Card>
      )}
        <Grid.Row>
          <Card centered>
            <Card.Content>
              <Card.Meta  style = {{color : "#000000",fontSize : '1.25em'}} >
                Enter you email to reset your account
              </Card.Meta>
            </Card.Content>
            <Card.Content>
              <Formik
                initialValues={{
                  email: "",
                }}
                validationSchema={schema}
                onSubmit={(values) => _resetPassword(values)}
              >
                {(props) => {
                  const {
                    values,
                    handleChange,
                    handleSubmit,
                    errors,
                    touched,
                  } = props;
                  return (
                    <Form onSubmit={handleSubmit}>
                      <Grid>
                        <Grid.Row>
                          <Grid.Column>
                            <Input
                              style={{ width: "100%" }}
                              name="email"
                              placeholder="Email"
                              values={values.email}
                              onChange={handleChange}
                              error={errors.email && touched.email}
                            />
                          </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                          <Grid.Column>
                            <Button     type="submit" style={{ backgroundColor: '#26f09e', color: '#000000'}}>
                              Reset Password
                            </Button>
                           
                          </Grid.Column>
                        </Grid.Row>
                      </Grid>
                    </Form>
                  );
                }}
              </Formik>
           
            </Card.Content>
          </Card>
        </Grid.Row>
      </Grid>
 

    </Container>
  );
};

export default ForgotPassword;
